import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PricingTableSession } from './models/pricing-table-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class PricingTableDialogService {
  private BASE_URL = `${environment.apiOrg.url}/organization/subscription`;

  constructor(private http: HttpClient) {}

  public generatePricingTableSessionClientSecret(): Observable<PricingTableSession> {
    return this.http.get<PricingTableSession>(`${this.BASE_URL}/pricing-table-session`);
  }
}
